import { computed, ref, type Ref } from 'vue';
import {
  buildAnswerRecapMatrix,
  sortMatrixRows,
  type AnswersByQuestion,
  type MatrixPlayer,
  type PlayedQuestion,
} from '../util/answerRecapMatrix';

type MatrixSources = {
  questions: Ref<PlayedQuestion[]>;
  answersByQuestion: Ref<AnswersByQuestion>;
  players: Ref<MatrixPlayer[]>;
};

export const useAnswerRecapMatrix = ({ questions, answersByQuestion, players }: MatrixSources) => {
  const openQuestionIndex = ref<number | null>(null);
  const openPlayerId = ref<string | null>(null);

  const matrix = computed(() => buildAnswerRecapMatrix(questions.value, answersByQuestion.value, players.value));

  // Columns stay in quiz order, so sorting rows cannot misalign a cell.
  const rows = computed(() => sortMatrixRows(matrix.value.rows));

  const openQuestion = computed(() =>
    openQuestionIndex.value === null
      ? null
      : (matrix.value.columns.find((column) => column.questionIndex === openQuestionIndex.value) ?? null),
  );

  const openPlayerRow = computed(() =>
    openPlayerId.value === null ? null : (matrix.value.rows.find((row) => row.playerId === openPlayerId.value) ?? null),
  );

  return { matrix, rows, openQuestionIndex, openPlayerId, openQuestion, openPlayerRow };
};
